// Client-side mirror of the Post model's related-link rules, so the composer
// gives immediate feedback. The backend stays the authority.

const ALLOWED_PROTOCOLS = ['http:', 'https:'];

// Whether `url` is an absolute http(s) URL (javascript:, ftp: and bare domains
// such as "futyclub.com" are rejected).
export const isValidLinkUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return ALLOWED_PROTOCOLS.includes(parsed.protocol) && parsed.hostname.length > 0;
  } catch {
    return false;
  }
};

// The Spanish error for a (url, title) pair, or undefined when it is valid.
// Both fields are optional, but a title needs a URL. Length limits are enforced
// by the inputs' maxlength and by the backend.
export const getPostLinkError = ({
  url,
  title,
}: {
  url: string;
  title: string;
}): string | undefined => {
  const trimmedUrl = url.trim();
  if (!trimmedUrl) {
    return title.trim() ? 'Si añades un título, también debes añadir el enlace' : undefined;
  }
  if (!isValidLinkUrl(trimmedUrl)) {
    return 'El enlace debe empezar por http:// o https://';
  }
  return undefined;
};
